import { render, staticRenderFns } from "./MessageDlg.vue?vue&type=template&id=504ee988"
import script from "./MessageDlg.vue?vue&type=script&lang=js"
export * from "./MessageDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/atlassian/application-data/bamboo/local-working-dir/AG-FRTPRSTD0-JOBCOMPILAR/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('504ee988')) {
      api.createRecord('504ee988', component.options)
    } else {
      api.reload('504ee988', component.options)
    }
    module.hot.accept("./MessageDlg.vue?vue&type=template&id=504ee988", function () {
      api.rerender('504ee988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MessageDlg.vue"
export default component.exports